import { render } from "./VaBeneCouponListPage.vue?vue&type=template&id=5e04e20e&ts=true"
import script from "./VaBeneCouponListPage.vue?vue&type=script&lang=ts"
export * from "./VaBeneCouponListPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__